import React from 'react';
import { SelectProps } from '@cad-arc';
import { FieldPath, FieldValues } from 'react-hook-form';
import { UserMultiSelect } from '../inputs/user-multi-select';
import { OptionOrOptions } from '../option';
import { CommonControlProps, IntegratedFormControl } from './integrated-form-control';

type UserMultiSelectProps = React.ComponentProps<typeof UserMultiSelect>;
type Props<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
> = CommonControlProps<TFieldValues, TName> & {
    userMultiSelectProps?: UserMultiSelectProps;
    truncateSelectedCount?: SelectProps['truncateSelectedCount'];
    cRef?: React.Ref<HTMLInputElement>; // 	https://fettblog.eu/typescript-react-generic-forward-refs/
};

export function FormUserMultiSelect<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>(props: Props<TFieldValues, TName>): React.ReactElement {
    const { userMultiSelectProps, truncateSelectedCount, ...integratedFormControlProps } = props;
    const renderViewMode = React.useCallback((value: OptionOrOptions) => {
        if (Array.isArray(value)) {
            if (value.length === 0) return '--';
            return value.map((option) => option.label).join(', ');
        }
        return value.label;
    }, []);
    return (
        <IntegratedFormControl {...integratedFormControlProps} renderViewMode={renderViewMode}>
            {(inputProps) => (
                <UserMultiSelect
                    {...inputProps}
                    {...userMultiSelectProps}
                    truncateSelectedCount={truncateSelectedCount}
                />
            )}
        </IntegratedFormControl>
    );
}
